module.exports = __webpack_public_path__ + "static/media/chiapas_aguaazul_trigosuave_44.a804217d.png";